import lodash from 'lodash';

import { userDefaultInstitutionIdSelector } from 'common/selectors';

import { formatStudyTeamMembers } from './formatStudyTeamMembers';
import { separateMetadataValues } from './separateMetadataValues';

export function getStudyTeamChanges(store) {
    const institutionId = userDefaultInstitutionIdSelector(store);
    const originalStudyId = lodash.get(store, 'study.originalFields.studyId', null);


    const originalStudyTeam = lodash.get(store, 'study.originalFields.studyTeam', []);
    const newStudyTeam = formatStudyTeamMembers(lodash.get(store, 'study.fields.studyTeam'), institutionId, originalStudyId);

    const studyTeamMembersToAdd = lodash.differenceBy(newStudyTeam, originalStudyTeam, 'userId');
    const studyTeamMembersToRemoveDiff = lodash.differenceBy(originalStudyTeam, newStudyTeam, 'userId');
    const studyTeamMembersToAddAndRemove = [...studyTeamMembersToAdd, ...studyTeamMembersToRemoveDiff];

    const studyTeamMembersNotAddedOrRemoved = lodash.differenceBy(newStudyTeam, studyTeamMembersToAddAndRemove, 'userId');

    const studyTeamMembersToUpdate = lodash.chain(studyTeamMembersNotAddedOrRemoved)
        .map(studyTeamMember => {
            const { studyRole, user, ...existingStudyTeamMember } = lodash.find(originalStudyTeam, ['userId', studyTeamMember.userId]);
            const nameOfResearcherChanged = studyTeamMember.nameOfResearcher !== existingStudyTeamMember.nameOfResearcher;
            const studyRoleChanged = studyTeamMember.studyRoleId !== existingStudyTeamMember.studyRoleId;

            if (nameOfResearcherChanged || studyRoleChanged) {
                // if study team member was removed / re-added, then 
                // they will be missing data (id). return the existing study
                // team member, with the fields changed.
                return {
                    ...existingStudyTeamMember,
                    nameOfResearcher: studyTeamMember.nameOfResearcher,
                    studyRoleId: studyTeamMember.studyRoleId,
                    sub: user.sub,
                };
            }
        })
        .compact()
        .value();

    let studyTeamMembersToRemove = [];

    studyTeamMembersToRemove = studyTeamMembersToRemoveDiff.map(member => {
        const { studyRole, user, ...memberToRemove } = member;
        return memberToRemove;
    });

    return { studyTeamMembersToAdd, studyTeamMembersToRemove, studyTeamMembersToUpdate };
}

export function getStudyMetadataChanges(store) {
    const institutionId = userDefaultInstitutionIdSelector(store);

    const originalStudyEssentials = lodash.get(store, 'study.originalFields.studyEssentials', {});
    const originalStudyDetails = lodash.get(store, 'study.originalFields.studyDetails', {});
    const newStudyEssentials = lodash.get(store, 'study.fields.studyEssentials');
    const newStudyDetails = lodash.get(store, 'study.fields.studyDetails');

    const newStudyEssentialsWithInstitution = newStudyEssentials.map((essential) => {
        return { ...essential, institutionId };
    });

    const {
        studyMetadataToAdd: studyEssentialsToAdd,
        studyMetadataToRemove: studyEssentialsToRemove,
    } = _getChanges(originalStudyEssentials, separateMetadataValues(newStudyEssentialsWithInstitution, 'essentials', 'name'));

    const {
        studyMetadataToAdd: studyDetailsToAdd,
        studyMetadataToRemove: studyDetailsToRemove,
    } = _getChanges(originalStudyDetails, separateMetadataValues(newStudyDetails, 'binder', 'descriptorId'));

    const studyMetadataToAdd = studyEssentialsToAdd.concat(studyDetailsToAdd);
    const studyMetadataToRemove = studyEssentialsToRemove.concat(studyDetailsToRemove);

    return { studyMetadataToAdd, studyMetadataToRemove };
}

function _getChanges(existingStudyMetadata, newStudyMetadata) {

    const studyMetadataToRemove = lodash.flatMap(existingStudyMetadata, (existingStudyMetadata, metadataGroupKey) => {
        const newStudyMetadataValues = lodash.get(newStudyMetadata, metadataGroupKey, []);
        return lodash.differenceBy(existingStudyMetadata, newStudyMetadataValues, 'value');
    });

    const studyMetadataToAdd = lodash.flatMap(newStudyMetadata, (newStudyMetadata, metadataGroupKey) => {
        const existingStudyMetadataValues = lodash.get(existingStudyMetadata, metadataGroupKey, []);
        return lodash.differenceBy(newStudyMetadata, existingStudyMetadataValues, 'value');
    });

    return { studyMetadataToAdd, studyMetadataToRemove };
}
